export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_KEY || '';

export const FIRST_DAY = 18;
export const LAST_DAY = 19;
export const YEAR = 2023;
export const LAST_YEAR = 2022;
export const SHORT_YEAR = '`23';

export const streams = {
  1: {
    live: 'https://youtube.com/live/SG88J8vCbHk?feature=share',
    embed: 'https://www.youtube.com/embed/SG88J8vCbHk'
  },
  2: {
    live: 'https://youtube.com/live/YYVQbhGk9sI?feature=share',
    embed: 'https://www.youtube.com/embed/YYVQbhGk9sI'
  },
  3: {
    live: 'https://youtube.com/live/FW99XO3hwr4?feature=share',
    embed: 'https://www.youtube.com/embed/FW99XO3hwr4'
  },
  4: {
    live: 'https://youtube.com/live/TmOmA2FlalE?feature=share',
    embed: 'https://www.youtube.com/embed/TmOmA2FlalE'
  },
  5: {
    live: 'https://youtube.com/live/bGmjoSX5tzg?feature=share',
    embed: 'https://www.youtube.com/embed/bGmjoSX5tzg'
  },
  6: {
    live: 'https://youtube.com/live/5Fo0s8ANraM?feature=share',
    embed: 'https://www.youtube.com/embed/5Fo0s8ANraM'
  }
};

export const trackNames = {
  tr1: 'Artificial Intelligence',
  tr2: 'Emerging Future',
  tr3: 'Applications and Architecture',
  tr4: 'Cloud',
  tr5: 'Digital Identity and Security',
  tr6: 'Lightning Talks and Panel Discussion'
};
